<template>
    <el-dialog
      v-if="visible"
      :title="title"
      :visible.sync="visible"
      width="80%"
      :append-to-body="true"
    >
          <avue-crud
            :option="option"
            :table-loading="loading"
            :data="data"
            :page.sync="page"
            ref="crud"
            @on-load="onLoad"
            @current-change="currentChange"
            @size-change="sizeChange"
            @refresh-change="onLoad"
            @selection-change="selectionChange"
          >

          </avue-crud>
    </el-dialog>

</template>
<script>


import {getInvoicePrintJournalList} from "@/api/v4ward/paylist/feepaylist";

export default {
  components: {

  },
  props: {
    feePayId:'',
    visible:false,

  },
  data() {
    return {
      data:[],
      title:'打印日志',
      option: {
        index: true,
        indexLabel: '序号',
        page: true,
        height: 'auto',
        calcHeight: 'auto',
        align: 'center',
        refreshBtn: false,
        viewBtn: false,
        searchBtn:false,
        columnBtn:false,
        searchShowBtn:false,
        menu: false,
        addBtn: false,
        editBtn: false,
        delBtn: false,
        border: true,
        column: [
          {
            label: '打印时间',
            prop: 'printTime',
          },

          {
            label: '打印人',
            prop: 'printManName',
          },
          {
            label: '票据号',
            prop: 'invoiceNo',
          },


        ],
      },
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      loading: false,
    };
  },
  watch:{
    visible(){
      this.$emit('update:visible',this.visible)
    }
  },
  created() {
  },
  methods: {
    handleClose(){},
    onLoad() {
      this.loading = true;
      if(this.feePayId){
        getInvoicePrintJournalList(Object.assign({},{ current: this.page.currentPage, size: this.page.pageSize }, {feePayId:this.feePayId})).then(({data})=>{
          this.data = data.records
          this.page.total = data.total
          this.loading = false;
        }).catch(()=>{
          this.loading = false;
        })
      }
    },
  },
};
</script>
<style>

</style>
